import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';

class TimeSlotDay extends Component {

  handleTimeSlotsSelect() {
    this.props.dispatchSelectTimeSlot(this.props.day.id);
  }

  getSelected() {
    return this.props.selectedTimeSlot === this.props.day.id;
  }

  render() {

    const {
      children,
      className,
      day
    } = this.props;

    if (!day) return;

    const classes = 'hg-timeSlotDay';
    const clickable = (day.available) ? this.handleTimeSlotsSelect.bind(this, day.id) : null;

    return (
      <td className={classNames(className, classes, { selected: this.getSelected()})}>
        <button type="button" className={classNames('s-install--content', 'x-body1', {disabled: !day.available})} onClick={clickable} disabled={!day.available}>
          {day.formatted}
        </button>
        {children}
      </td>
    );
  }
}

TimeSlotDay.propTypes = {
  children: PropTypes.node,
  dispatchSelectTimeSlot: PropTypes.func.isRequired,
  className: PropTypes.object,
  selectedTimeSlot: PropTypes.string,
  day: PropTypes.object.isRequired,
  setSelectedTimeSlot: PropTypes.func,
};

export default TimeSlotDay;



/** WEBPACK FOOTER **
 ** ./client/shared/packages/TimeSlotCalendar/src/TimeSlotDay/TimeSlotDay.jsx
 **/